import Camera from "../../assets/icon/NewsIcons/MainAdmin/NewsCamera"
import {MainAdminAddAdvertising} from "../../components"
import React, { useState, useEffect } from "react";
import Cookies from 'universal-cookie';
import { axiosReq } from "../../commons/axiosReq";
import { useNavigate } from "react-router-dom";

const MainAdminDefinitionAdvertising = () => {


    const [reCheck, setRecheck] = useState(false);
    const [data, setData] = useState();
     
            const [count, setCount] = useState();
      
              let navigate = useNavigate();
        
       
               const GetData = async () => {
                    const writersData = await axiosReq("Advertisement/GetAds", "get");
                    console.log("slm")
                    console.log(writersData)
                    setData(writersData)
                }
                const auth = async () => {
                        const cookies = new Cookies();
                        var token = cookies.get('token');
                        console.log(token)
                        console.log(cookies.get('role'))
                        if (!token) {
                            navigate("/admin");
                        } else {
                            if( cookies.get('role')=="Admin" )
                           {
                
                               GetData()
                           }
                
                            
                            else {
                                navigate("/admin");
                
                            }
                        }
                    }
                useEffect(() => {
            
                    auth();
                }, [reCheck]);

    return(
        <div >
            <div className="flex items-center border-b-2 border-borderGray p-[20px]">
                <div className="flex items-center">
                    <div><Camera color={'#184548'}/></div>
                    <p className="font-IRANYekanExtra text-[15px] text-mainColor2 mr-[15px]">تعریف تبلیغات</p>
                </div>
            </div>
            <div className="flex flex-wrap pt-[25px] pb-[61px] px-[20px]">
                <div className="w-[48%] h-[433px] mb-[27px]"><MainAdminAddAdvertising /></div>
                <div className="w-[48%] h-[433px] mr-[4%] mb-[27px]"><MainAdminAddAdvertising /></div>
                <div className="w-[48%] h-[433px] mb-[27px]"><MainAdminAddAdvertising /></div>
                <div className="w-[48%] h-[433px] mr-[4%] mb-[27px]"><MainAdminAddAdvertising /></div>
            </div>
        </div>
    )
}

export default MainAdminDefinitionAdvertising;